import axios from "axios";
import { GameLobbyType } from "models/GameLobbyType";
import { getAuthToken } from "utils/auth_helpers";
import { BASE_URL } from "utils/constants";

export const leaveGameLobby: (lobbyId: string) => Promise<GameLobbyType | null> = (lobbyId) => {
  axios.defaults.baseURL = BASE_URL;
  axios.defaults.headers.get["Content-Type"] = "application/json";
  axios.defaults.headers.common["Authorization"] = `Bearer ${getAuthToken()}`;

  return axios
    .post(`/api/game-lobby/${lobbyId}/leave`, {})
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      console.log("Failure");
      console.log(err);
      return null;
    });
};
